module.exports = __webpack_public_path__ + "fonts/HelveticaNeue-Medium.7c3f6756.woff";